module.exports = __webpack_public_path__ + "img/tclog.f3044f4.png";